const ruRU = {
  buttons: {
    cancel: 'Отмена',
    save: 'Сохранить',
    create: 'Создать',
    close: 'Закрыть',
    exit: 'Выход',
    add: 'Добавить',
    filter: 'Фильтр',
    refresh: 'Обновить',
    'get-report': 'Сформировать'
  },
  forms: {
    'no-data-label': 'На данный момент таблица пуста. Используйте фильтр.',
    'document-updated': 'Документ успешно обновлен',
    'document-saved': 'Документ успешно сохранен',
    'new-document': 'Новый документ',
    document: 'Документ №',
    'document-date': ' от ',
    'report-cash-movement': {
        name: 'Финансовый отчет'
    },
    'adjustment-cash-register': {
        name: 'Корректировка финансов',
        incoming: 'Поступление',
        outcoming: 'Расход',
        comment: 'Комментарий',
        sum: 'Сумма',
        register: 'Реестр',
        'factoring-organization': 'Факторинговая организация',
        'document-type': 'Тип документа',
    },
    dashboard: {
        name: 'Рабочий стол',
        widgets: {
            calculator: {
                name: 'Калькулятор'
            }
        }
    },
    'register': {
        name: 'Реестр',
        sum: 'Запрашиваемая сумма',
        organization: 'Организация',
        'factoring-organization': 'Факторинговая организация',
        status: 'Статус',
        comment: 'Комментарий',
        register: 'Реестр',
        'document-type': 'Тип документа',
    },
    login: {
      'form-name': 'Вход',
      email: 'Email',
      username: 'Имя пользователя',
      password: 'Пароль',
      'remember-me': 'Запомнить меня',
      'forgot-password': 'Забыли пароль?',
      'sign-in': 'Войти',
      'sign-up-question': 'Еще не зарегистрированы?',
      'sign-up': 'Создать аккаунт',
    },
    registration: {
      'form-name': 'Регистрация',
      name: 'Как к вам обращаться?',
      email: 'Email',
      phone: 'Телефон',
      password: 'Пароль',
      'password-repeat': 'Повторите пароль',
      accept: 'Согласен с политикой обработки персональных данных',
      'sign-in-question': 'Уже зарегистрированы?',
      'sign-in': 'Войти в аккаунт',
      'sign-up': 'Зарегистрироваться',
      'policy-link': 'Политика обработки персональных данных',
    },
    'user-information': {
      'client-number' : 'Ваш номер клиента',
      'phone-number': 'Номер телефона',
      'email': 'Электронная почта',
      'user-name': 'Имя пользователя',
      'user-role': 'Роль пользователя'
    },
    'common-side-bar': {
      organization: 'Организация',
      other: 'Другое',
      rmk: 'РМК',
      settings: 'Настройки',
      account: 'Аккаунт',
      user: 'Пользователь',
      exit: 'Выход',
      reports: 'Отчеты',
      references: 'Справочники',
      documents: 'Документы'
    },
    'add-new-organization': {
      'form-name': 'Добавить организацию',
      name: 'Наименование организации',
      email: 'e-mail',
      'name-hint': 'Для удобного поиска',
      address: 'Адрес организации',
      'full-name': 'Полное наименование организации',
      'lang': 'Предпочитаемый язык'
    },
    'organization-list': {
      'organization-list': 'Ваши организации',
      'extra-organization-list': 'Организации, к которым вам предоставлен доступ'
    },
    'document-headers': {
      'author'       : 'Автор',
      'id'           : 'ID',
      'date'         : 'Дата',
      'contractor_id': 'Контрагент',
      'stock_id'     : 'Склад',
      'sum'          : 'Сумма',
      'user_id'      : 'Пользователь',
      'number'       : 'Номер',
      'comment'      : 'Комментарий',
      'contractor_agreement_id': 'Договор с контрагентом',
      'contractor_agreement'   : 'Договор с контрагентом',
      'u_id'         : 'UID',
      'name'         : 'Имя',
      'bik'          : 'БИК',
      'mrp'          : 'МРП',
      'mzp'          : 'МЗП',
      'organization_id'        : 'Организация',
      'currency_id'  : 'Валюта',
      'currency'     : 'Валюта',
      'title'        : 'Название',
      'parent_id'    : 'Родитель',
      'is_group'     : 'Группа',
      'is_service'   : 'Услуга',
      'full_name'    : 'Полное имя',
      'iin_bin'      : 'ИИН/БИН',
      'email'        : 'Почта',
      'phone'        : 'Телефон',
      'governmental' : 'Гос. учереждение',
      'kbe'          : 'КБЕ',
      'address'      : 'Адрес',
      'code'         : 'Артикул',
      'code_symbol'  : 'Кодовый символ',
      'name_ru'      : 'Название RU',
      'name_kz'      : 'Название KZ',
      'name_en'      : 'Название EN',
      'last_name'    : 'Фамилия',
      'first_name'   : 'Имя',
      'middle_name'  : 'Отчество',
      'dob'          : 'Дата рождения',
      'sex'          : 'Пол',
      'is_director'  : 'Руководитель',
      'document_type': 'Тип документа',
      'serial'       : 'Серийный номер',
      'issued'       : 'ВЫпущено',
      'pensioner'    : 'Пенсионер',
      'oppv'         : 'ОППВ',
      'position'     : 'Должность',
      'employment_date'        : 'Дата найма',
      'date_of_dismissal'      : 'дата увольнения',
      'payment_type' : 'Тип оплаты',
      'payment_value': 'Сумма оплаты',
      'calendar_type': 'Тип календаря',
      'combination'  : 'Совмещение',
      'price'        : 'Цена, ₸',
      'weight'       : 'Вес',
      'logo'         : 'Логотип',
      'organization_type'      : 'Тип организации',
      'billing'      : 'Подписка',
      'registration_date'      : 'Дата регистрации',
      'language'     : 'Язык',
      'api_token'    : 'API ключ',
      'boss_id'      : 'Директор',
      'accountant_id': 'Главный бухгалтер',
      'full_name_ru' : 'Полное имя RU',
      'full_name_kz' : 'Полное имя KZ',
      'full_name_en' : 'Полное имя EN',
      'solution'     : 'Решение',
      'expire_date'  : 'Дата окончания',
      'unit_id'      : 'Ед. изм.',
      'unit'         : 'Ед. изм.',
      'nomenclature_id'        : 'Товар/Услуга',
      'nomenclature' : 'Товар/Услуга',
      'amount'       : 'Количество',
      'is_active'    : 'Активность',
      'percent'      : 'Процент',
      'contractor'   : 'Поставщик/покупатель',
      'stock'        : 'Склад',
      'number_of_tables'       : 'Количество столов',
      'cashbox'      : 'Касса',
      'stock_in'     : 'Склад отправитель',
      'stock_out'    : 'Склад получатель',
      'income'       : 'Я должен',
      'outcome'      : 'Мне должны',
      'from'         : 'Принято от',
      'cash_receipt_type'      : 'Тип операции',
      'to'           : 'Получатель',
      'type'         : 'Тип',
      'amount_expected' : 'Сумма факт',
      'amount_real'     : 'Количество факт',
      'sum_expected'    : 'Сумма бух.',
      'sum_real'        : 'Количество бух.',
      'discount_percent': 'Процент скидки',
      'is_paid': 'Оплачен',
      'organization_name': 'Организация',
      'factoring_organization_name': 'Факторинговые организация',
      'debtor_name': 'Дебитор',
    }
  },
  errors: {
    required: 'Это поле обязательно для заполнения',
    invalid: 'Недопустимый формат',
    email: 'Недопустимый формат email',
    password: 'Недопустимый формат пароля',
    'access-denied': 'Неправильный логин или пароль',
    'server-error': 'Ошибка сервера',
    iin: 'Недопустимый формат ИИН/БИН',
    name: 'Наименование должно быть заполнено',
    address: 'Адрес должен быть заполнен',
    'full-name': 'Полное наименование должно быть заполнено',
    expired: 'Подписка истекла',
  },
  notifications: {
    success: 'Успешно',
    error: 'Ошибка',
    'exit-confirm': 'Вы действительно хотите выйти?'
  }
}

export { ruRU }
